import React from 'react';

const About = () => {
    return (
        <div>
           <h1>About Me</h1> 

           <h4>Name: Avijit Saha</h4>
           <p>Goal: From now to next Four or Five Month I discover myself as a Web Developer. From 31 december, 2021 I started a journey with PHero. <br/> I enjoyed it and this course totaly changed me. Now I can know how to work hard, how to maintain time, how to be disciplined.
           Besides this i also read and learn how to read doccumentation. As a developer reading doccumentation is very important. I love this journey with Phero.</p>
        </div>
    );
};

export default About;